import { useQuery } from '@tanstack/react-query';
import { dashboardService } from '../services/dashboard.service';
import type { DashboardStats } from '../types/dashboard.types';

export const DASHBOARD_STATS_QUERY_KEY = ['dashboard', 'stats'] as const;

interface UseDashboardStatsReturn {
  stats: DashboardStats | undefined;
  isLoading: boolean;
  isError: boolean;
  error: Error | null;
  refetch: () => void;
}

export function useDashboardStats(): UseDashboardStatsReturn {
  const query = useQuery({
    queryKey: DASHBOARD_STATS_QUERY_KEY,
    queryFn: () => dashboardService.getStats(),
  });

  return {
    stats: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
}
